import {ContentRoute} from "../../models/Route";
import {objeto_contrato_content_routes} from "./objetocontrato";


const routes: Array<ContentRoute> =
    objeto_contrato_content_routes

export default routes;